import type { LocalDate } from "@js-joda/core";
import type { StaffProfileData } from "services/api/company/staff.service";
import { getStockholmLocalDateNow } from "web-apps/company/utils/timeAndDate";
import { toLocalDateOrNull } from "../domains/employment/profilePanel.payload.logic";
import { performSaveEmployment as runPerformSaveEmployment } from "./profilePanel.state.employment.logic";
import { toEmploymentDetailsForm } from "./profilePanel.state.formMappers.logic";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

interface ConfirmEndEmploymentUpdateParams {
  companyId: number | null;
  employmentRules: ReturnType<
    typeof import("../domains/employment/profilePanel.rules.logic").toEmploymentUiRules
  >;
  endEmploymentDate: LocalDate | null;
  isSaving: boolean;
  onSuccess: () => void;
  onWorkerUpdated?: () => void;
  profile: StaffProfileData | null;
  reloadProfile: () => void;
  setIsSaving: (value: boolean) => void;
  setSaveError: (value: string) => void;
  translate: TranslateFn;
  workerId: number | null;
}

export const toSuggestedEndEmploymentDate = (
  currentEmploymentStartDate: LocalDate | null,
): LocalDate => {
  const today = getStockholmLocalDateNow();

  return currentEmploymentStartDate != null &&
    today.isBefore(currentEmploymentStartDate)
    ? currentEmploymentStartDate
    : today;
};

export const confirmEndEmploymentUpdate = (
  params: ConfirmEndEmploymentUpdateParams,
): void => {
  if (params.isSaving) return;
  if (params.endEmploymentDate == null) {
    params.setSaveError(params.translate("Alerts.SomethingWentWrong"));
    return;
  }

  const currentEmployment = params.profile?.employmentInfo?.current;
  const startDate = toLocalDateOrNull(currentEmployment?.startDate);

  runPerformSaveEmployment({
    companyId: params.companyId,
    workerId: params.workerId,
    profile: params.profile,
    editedEmploymentDetails: toEmploymentDetailsForm(params.profile),
    employmentSaveMode: "update",
    editingTab: "employmentSalary",
    employmentRules: params.employmentRules,
    startDate,
    endDate: params.endEmploymentDate,
    translate: params.translate,
    setIsSaving: params.setIsSaving,
    setSaveError: params.setSaveError,
    setEditingTab: (): void => undefined,
    setEmploymentSaveMode: (): void => undefined,
    setModalState: (): void => params.onSuccess(),
    reloadProfile: params.reloadProfile,
    onWorkerUpdated: params.onWorkerUpdated,
  });
};
